/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    CodeAndLabel,
    CodeAndLabelFromJSON,
    CodeAndLabelFromJSONTyped,
    CodeAndLabelToJSON,
    DateTimeRestrictionData,
    DateTimeRestrictionDataFromJSON,
    DateTimeRestrictionDataFromJSONTyped,
    DateTimeRestrictionDataToJSON,
    FormDataRouteRestriction,
    FormDataRouteRestrictionFromJSON,
    FormDataRouteRestrictionFromJSONTyped,
    FormDataRouteRestrictionToJSON,
    Int32IdAndLabel,
    Int32IdAndLabelFromJSON,
    Int32IdAndLabelFromJSONTyped,
    Int32IdAndLabelToJSON,
    RuleFormDataAgencyOrGroup,
    RuleFormDataAgencyOrGroupFromJSON,
    RuleFormDataAgencyOrGroupFromJSONTyped,
    RuleFormDataAgencyOrGroupToJSON,
    SearchTravelRange,
    SearchTravelRangeFromJSON,
    SearchTravelRangeFromJSONTyped,
    SearchTravelRangeToJSON,
} from './';

/**
 * 
 * @export
 * @interface SearchRuleFormData
 */
export interface SearchRuleFormData {
    /**
     * 
     * @type {string}
     * @memberof SearchRuleFormData
     */
    id?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SearchRuleFormData
     */
    disabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SearchRuleFormData
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SearchRuleFormData
     */
    comment?: string | null;
    /**
     * 
     * @type {number}
     * @memberof SearchRuleFormData
     */
    relevance?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchRuleFormData
     */
    maxPriceSolutions?: number | null;
    /**
     * 
     * @type {number}
     * @memberof SearchRuleFormData
     */
    maxPricePoints?: number | null;
    /**
     * 
     * @type {Array<DateTimeRestrictionData>}
     * @memberof SearchRuleFormData
     */
    dateTimeRestrictions?: Array<DateTimeRestrictionData> | null;
    /**
     * 
     * @type {CodeAndLabel}
     * @memberof SearchRuleFormData
     */
    dateTimeRestrictionsTimeZone?: CodeAndLabel;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof SearchRuleFormData
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {Array<Int32IdAndLabel>}
     * @memberof SearchRuleFormData
     */
    distributionChannels?: Array<Int32IdAndLabel> | null;
    /**
     * 
     * @type {Array<RuleFormDataAgencyOrGroup>}
     * @memberof SearchRuleFormData
     */
    agenciesAndGroups?: Array<RuleFormDataAgencyOrGroup> | null;
    /**
     * 
     * @type {Array<FormDataRouteRestriction>}
     * @memberof SearchRuleFormData
     */
    routes?: Array<FormDataRouteRestriction> | null;
    /**
     * 
     * @type {Array<CodeAndLabel>}
     * @memberof SearchRuleFormData
     */
    salesJourneys?: Array<CodeAndLabel> | null;
    /**
     * 
     * @type {string}
     * @memberof SearchRuleFormData
     */
    cloneSourceId?: string | null;
    /**
     * 
     * @type {Array<SearchTravelRange>}
     * @memberof SearchRuleFormData
     */
    travelDates?: Array<SearchTravelRange> | null;
    /**
     * 
     * @type {boolean}
     * @memberof SearchRuleFormData
     */
    allowEdit?: boolean;
}

export function SearchRuleFormDataFromJSON(json: any): SearchRuleFormData {
    return SearchRuleFormDataFromJSONTyped(json, false);
}

export function SearchRuleFormDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchRuleFormData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'comment': !exists(json, 'comment') ? undefined : json['comment'],
        'relevance': !exists(json, 'relevance') ? undefined : json['relevance'],
        'maxPriceSolutions': !exists(json, 'maxPriceSolutions') ? undefined : json['maxPriceSolutions'],
        'maxPricePoints': !exists(json, 'maxPricePoints') ? undefined : json['maxPricePoints'],
        'dateTimeRestrictions': !exists(json, 'dateTimeRestrictions') ? undefined : (json['dateTimeRestrictions'] === null ? null : (json['dateTimeRestrictions'] as Array<any>).map(DateTimeRestrictionDataFromJSON)),
        'dateTimeRestrictionsTimeZone': !exists(json, 'dateTimeRestrictionsTimeZone') ? undefined : CodeAndLabelFromJSON(json['dateTimeRestrictionsTimeZone']),
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'distributionChannels': !exists(json, 'distributionChannels') ? undefined : (json['distributionChannels'] === null ? null : (json['distributionChannels'] as Array<any>).map(Int32IdAndLabelFromJSON)),
        'agenciesAndGroups': !exists(json, 'agenciesAndGroups') ? undefined : (json['agenciesAndGroups'] === null ? null : (json['agenciesAndGroups'] as Array<any>).map(RuleFormDataAgencyOrGroupFromJSON)),
        'routes': !exists(json, 'routes') ? undefined : (json['routes'] === null ? null : (json['routes'] as Array<any>).map(FormDataRouteRestrictionFromJSON)),
        'salesJourneys': !exists(json, 'salesJourneys') ? undefined : (json['salesJourneys'] === null ? null : (json['salesJourneys'] as Array<any>).map(CodeAndLabelFromJSON)),
        'cloneSourceId': !exists(json, 'cloneSourceId') ? undefined : json['cloneSourceId'],
        'travelDates': !exists(json, 'travelDates') ? undefined : (json['travelDates'] === null ? null : (json['travelDates'] as Array<any>).map(SearchTravelRangeFromJSON)),
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
    };
}

export function SearchRuleFormDataToJSON(value?: SearchRuleFormData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'disabled': value.disabled,
        'description': value.description,
        'comment': value.comment,
        'relevance': value.relevance,
        'maxPriceSolutions': value.maxPriceSolutions,
        'maxPricePoints': value.maxPricePoints,
        'dateTimeRestrictions': value.dateTimeRestrictions === undefined ? undefined : (value.dateTimeRestrictions === null ? null : (value.dateTimeRestrictions as Array<any>).map(DateTimeRestrictionDataToJSON)),
        'dateTimeRestrictionsTimeZone': CodeAndLabelToJSON(value.dateTimeRestrictionsTimeZone),
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'distributionChannels': value.distributionChannels === undefined ? undefined : (value.distributionChannels === null ? null : (value.distributionChannels as Array<any>).map(Int32IdAndLabelToJSON)),
        'agenciesAndGroups': value.agenciesAndGroups === undefined ? undefined : (value.agenciesAndGroups === null ? null : (value.agenciesAndGroups as Array<any>).map(RuleFormDataAgencyOrGroupToJSON)),
        'routes': value.routes === undefined ? undefined : (value.routes === null ? null : (value.routes as Array<any>).map(FormDataRouteRestrictionToJSON)),
        'salesJourneys': value.salesJourneys === undefined ? undefined : (value.salesJourneys === null ? null : (value.salesJourneys as Array<any>).map(CodeAndLabelToJSON)),
        'cloneSourceId': value.cloneSourceId,
        'travelDates': value.travelDates === undefined ? undefined : (value.travelDates === null ? null : (value.travelDates as Array<any>).map(SearchTravelRangeToJSON)),
        'allowEdit': value.allowEdit,
    };
}


